import { Col, Row } from 'antd';
import React from 'react';
import UserStore from 'stores/UserStore';
import UTMQueryPreservingLink from '../../common/UTMQueryPreservingLink';
import ReportProblemLink from '../ReportProblemLink';

const Footer = () => {
    return (
        <footer className="portal-footer">
            <div className="container">
                <Row gutter={[0, 16]}>
                    <Col md={8} span={12}>
                        <div className="d-flex flex-column">
                            <span className="section-header">Links</span>
                            <UTMQueryPreservingLink to="/rapid-quote/start">Get a Quote</UTMQueryPreservingLink>

                            {UserStore.isAuthenticated ? (
                                <>
                                    <UTMQueryPreservingLink to="/my-account/settings">Account</UTMQueryPreservingLink>
                                    <UTMQueryPreservingLink to="/my-account/quotes">Quotes</UTMQueryPreservingLink>
                                    <UTMQueryPreservingLink to="/my-account/orders">Orders</UTMQueryPreservingLink>
                                    <UTMQueryPreservingLink to="/my-account/parts" className="mb-3">
                                        Parts
                                    </UTMQueryPreservingLink>
                                </>
                            ) : null}

                            <a href="https://parts-badger.com/terms-of-use/" target="_blank" rel="noopener noreferrer">
                                Terms & Conditions
                            </a>
                            <a href="https://parts-badger.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
                                Privacy Policy
                            </a>
                        </div>
                    </Col>

                    <Col md={8} span={12}>
                        <div className="d-flex flex-column">
                            <div className="d-flex flex-column">
                                <span className="section-header">Contact Us</span>
                                {UserStore.isAuthenticated ? (
                                    <>
                                        <UTMQueryPreservingLink to="/my-account/support" className="mb-3">
                                            Help & Support
                                        </UTMQueryPreservingLink>
                                        <span className="mb-3">
                                            <ReportProblemLink />
                                        </span>
                                    </>
                                ) : null}
                                <span className="mb-3">
                                    Phone: 331-BADGER-8
                                    <br /> <i>(331) 223-4378</i>
                                    <br />
                                    8am-5pm CST M-F
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col md={8} span={12}>
                        <div className="d-flex flex-column">
                            <span className="section-header">Address</span>
                            <div>
                                <address>
                                    PartsBadger
                                    <br />
                                    W66N205 Commerce Ct. <br />
                                    Cedarburg, WI 53012
                                </address>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </footer>
    );
};

export default Footer;
